import * as React from 'react';
import ouiBase from '@goldwasserexchange/oui';
import { LinkedBondDetailLineContainer, LinkedBondDetailLineLabel, LinkedBondDetailLineValue } from './components';

export const LinkedBondDetailLine = (props: {
  secondaryDimension: string,
  withoutBorder?: boolean,
}) => {
  const {
    secondaryDimension,
    withoutBorder,
  } = props;
  return (
    <ouiBase.utils.dimensions.CurrentSecondaryDimensionContextProvider
      currentSecondaryDimension={secondaryDimension}
    >
      <LinkedBondDetailLineContainer
        withoutBorder={withoutBorder}
      >
        <LinkedBondDetailLineLabel />
        <LinkedBondDetailLineValue />
      </LinkedBondDetailLineContainer>
    </ouiBase.utils.dimensions.CurrentSecondaryDimensionContextProvider>
  );
};
